import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'

export function Logout() {
  const clearState = useAuthStore(state => state.clearState, shallow)

  useEffect(() => {
    clearState()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Navigate to='/auth' />
}
